import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "@/assets/global.css";
import "element-plus/dist/index.css";
import { createHead } from "@unhead/vue/client";
// 使用 CDN 引入 Font Awesome，避免字体文件路径问题
const link = document.createElement("link");
link.href =
  "https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.7.2/css/all.min.css";
link.rel = "stylesheet";
document.head.appendChild(link);
import { createPinia } from "pinia"; //登入状态管理
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"; //使用 Pinia 的持久化存储功能
import * as ElementPlusIIconsVue from "@element-plus/icons-vue";
import annotationPlugin from "chartjs-plugin-annotation";
import Chart from "chart.js/auto"; // 核心库
// import pinia from "./store"; // 引入 Pinia 实例

// 注册插件到 Chart
Chart.register(annotationPlugin);
// 创建 Pinia 实例
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate); // 先注册插件到 Pinia，添加持久化插件
// 创建 unhead 实例
const head = createHead();

createApp(App)
  .use(router)
  .use(ElementPlus, { locale: zhCn })
  .use(pinia)
  .use(head) // 注册 head 管理
  .mount("#app");
// for (const [key, component] of Object.entries(ElementPlusIIconsVue)) {
//   App.component(key, component);
// }
